import Skeleton from './Skeleton';

type ChartSkeletonProps = {
  height: number;
};

const ChartSkeleton = ({ height }: ChartSkeletonProps) => (
  <section aria-busy="true" aria-label="Carregando gráfico" style={{ height }}>
    <output className="visually-hidden">Carregando gráfico...</output>
    <div aria-hidden="true" className="d-flex align-items-end gap-4 h-100 border-start border-bottom p-5">
      {[45, 70, 55, 85, 65, 95, 75, 60].map((barHeight) => (
        <Skeleton key={barHeight} height={`${barHeight}%`} width="12.5%" />
      ))}
    </div>
  </section>
);

export default ChartSkeleton;
